import { create } from 'zustand'

import { MyTeamsFilters } from '../../../api/earnings/types'

type MyTeamsEarnings = {
  myTeamsEarningsFilters: MyTeamsFilters | undefined
  setMyTeamsEarningsFilters: (x: MyTeamsFilters | undefined) => void
}
const useMyTeamsEarningsStore = create<MyTeamsEarnings>((set) => ({
  myTeamsEarningsFilters: { brands: [], paymentStatus: [] },
  setMyTeamsEarningsFilters: (filters) =>
    set((state) => ({ ...state, myTeamsEarningsFilters: filters })),
}))

export default useMyTeamsEarningsStore
